export default __webpack_public_path__ + "static/media/spaakring_verend_3x.5ab01c22.png";